export const REDIRECT_FROM_AUTH_PATH_KEY = 'redirectFromAuthPath';
